import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { AxiosAdapter } from '../../../../_config/v2/adapters/axios/axios.adapter';
import { Http } from '../../../../_config/v2/adapters/axios/axios.protocols';

export class Service {
	// async getMagistralQuotation(payload, page) {
	// 	return new AxiosAdapter({
	// 		method: Http.POST,
	// 		url: `${Enviroment.FUNCTION_QUOTATION}/CL/list`,
	// 		data: payload,
	// 		params: { page: page },
	// 	})
	// 		.request()
	// 		.then((response) => {
	// 			return response;
	// 		})
	// 		.catch((e) => {
	// 			return e;
	// 		});
	// }

	async getMagistralQuotation(payload) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_BACKEND}/quotations-magistral`,
			params: payload,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
